import React from 'react';
import type { DefaultAutomationTemplateMetadata } from '@reach/shared-types/automation-template';
import { TemplateCard } from './TemplateCard';
import styles from './CreateTemplateDialog.module.css';

interface TemplateListProps {
  templates: DefaultAutomationTemplateMetadata[];
  onSelectTemplate: (templateName: string) => void;
}

export const TemplateList: React.FC<TemplateListProps> = ({
  templates,
  onSelectTemplate,
}) => {
  return (
    <ul className={styles.templateList}>
      {templates.map(template => (
        <li key={template.name}>
          <TemplateCard template={template} onSelect={onSelectTemplate} />
        </li>
      ))}
    </ul>
  );
};
